import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AuthService } from '../auth/auth.service';
import { AuthGuard } from '../auth/auth.guard';
import { HelpComponent } from './help.component';
import { router } from './help.routes';

@NgModule({
  declarations: [HelpComponent],
  imports: [BrowserModule, TranslateModule.forRoot(), router],
  providers: [AuthGuard, AuthService]
})
export class HelpModule {}



// WEBPACK FOOTER //
// ./src/app/modules/help/help.module.ts